import { render, staticRenderFns } from "./wechatUserInfoIndex.vue?vue&type=template&id=67f1fa4c&scoped=true"
import script from "./wechatUserInfoIndex.vue?vue&type=script&lang=js"
export * from "./wechatUserInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./wechatUserInfoIndex.vue?vue&type=style&index=0&id=67f1fa4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1fa4c",
  null
  
)

export default component.exports